import { trackMixpanelEvent } from "../../utils/helpers"
import { DOCUMENT_ASSESSMENT_STAGE } from "../constants"
import { ASSESSMENTS_EVENTS } from "../constants/MIXAPANEL_EVENTS"

export const getAssessmentTrackersData = (
    entity: string,
    stage: string,
    isVasFlow: boolean,
    source?: string
) => {
    const eventSource = isVasFlow ? "VAS" : "Application Flow Enrichment"
    switch (stage) {
        case DOCUMENT_ASSESSMENT_STAGE.UPLOAD_CTA_CLICK:
            return trackMixpanelEvent(ASSESSMENTS_EVENTS.UPLOAD_DOCUMENT_CTA_CLICKED, {
                Source: eventSource,
                entity_type: entity,
            })
        case DOCUMENT_ASSESSMENT_STAGE.ADD_DOCUMENT_CLICK:
            return trackMixpanelEvent(ASSESSMENTS_EVENTS.ADD_DOCUMENT_CLICKED, {
                Source: eventSource,
                "Upload Source": source,
            })
        case DOCUMENT_ASSESSMENT_STAGE.DOCUMENT_REMOVED_CLICK:
            return trackMixpanelEvent(ASSESSMENTS_EVENTS.DOCUMENT_REMOVED, {
                Source: eventSource,
                entity_type: entity,
            })
        // Upload cancel click
        case DOCUMENT_ASSESSMENT_STAGE.DOCUMENT_UPLOAD_INITIATED:
            return trackMixpanelEvent(ASSESSMENTS_EVENTS.DOCUMENT_UPLOAD_INITIATED, {
                Source: eventSource,
                entity_type: entity,
            })
        case DOCUMENT_ASSESSMENT_STAGE.DOCUMENT_UPLOAD_SUCCESS:
            return trackMixpanelEvent(ASSESSMENTS_EVENTS.DOCUMENT_UPLOAD_SUCCESS, {
                Source: eventSource,
                entity_type: entity,
            })
        case DOCUMENT_ASSESSMENT_STAGE.DOCUMENT_UPLOAD_FAILURE:
            return trackMixpanelEvent(ASSESSMENTS_EVENTS.DOCUMENT_UPLOAD_FAILURE, {
                Source: eventSource,
                entity_type: entity,
            })
    }
}
